import React from "react";
import "../../App.css";
import { Layout, Menu, Dropdown, Icon } from "antd";
// import log from '../../assets/logo.gif'
import logTW from "../../assets/logo-tw.png";
import logDL from "../../assets/logo-dl.png";
import lanPic from "../../assets/images/header-language.png";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { routes } from "../../routes";
import { withTranslation } from "react-i18next";
import i18n from "i18next";
const { Header } = Layout;
const getKey = (pathname) => {
  let arr = [];
  routes.forEach(({ path }) => {
    if (pathname && pathname.includes(path)) {
      //当当前的pathname 包含该路由，那么选中的key是
      arr.push(path);
    }
  });
  if (arr.length === 0) {
    arr = ["/index"];
  }
  return arr;
};
const lan = ["简体中文", "繁體中文", "English", "Tiếng việt nam", "ไทย"];
const title = [
  "服务云",
  "服務雲",
  "Digiwin Cloud Service Manager",
  "Đám mây dịch vụ Digiwin",
  "การบริการคลาวเซอร์วิส",
];
let url = window.location.host;
//let dlLocation = 'http://es-ygj.digiwincloud.com.cn'//大陆
let twLocation = "es-ygj.digiwincloud.com"; //台湾
let isTW = false;

class Head extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyId: "",
      languageType: "zh",
      log: logDL,
      routesList: [].concat(routes),
    };
  }
  changeLan = (visible) => {
    this.setState({
      keyId: visible.key,
    });
    if(url === twLocation){
      if(visible.key === "0"){
        document.title = "服務雲";
      } else {
        document.title = title[visible.key];
      }
    } else {
      if(visible.key === "1"){
        document.title = "服务云";
      }
      else {
        document.title = title[visible.key];
      }
    }
    //document.title = title[visible.key];
    this.changeLang(visible.key);
  };
  changeLang(code) {
    let lan;
    switch (code) {
      case "0":
        lan = i18n.changeLanguage("zhCN");
        break;
      case "1":
        lan = i18n.changeLanguage("zhTW");
        break;
      case "2":
        lan = i18n.changeLanguage("zhEN");
        break;
      case "3":
        lan = i18n.changeLanguage("zhVN"); //越南
        break;
      case "4":
        lan = i18n.changeLanguage("zhTHAI"); //泰语
        break;
      default:
        lan = i18n.changeLanguage("zhCN");
    }
  }
  changePath(parth) {
    this.props.history.push({ pathname: parth });
  }
  changMenu = (e) => {
    console.log(e);
    let tree;
    switch (e.key) {
      case "first":
        tree = this.changePath("/");
        break;
      case "second":
        let openUrl=''
        const protocol = window.location.protocol;
        //依不同域名打开不同链接
        if(url === twLocation){
          if (protocol === 'https:') {
              openUrl='https://aieom.digiwincloud.com/#/publicity'
          } else if (protocol === 'http:') {
              openUrl='http://aieom.digiwincloud.com/#/publicity'
          }        
        } else {
          if (protocol === 'https:') {
            openUrl='https://aieom.digiwincloud.com.cn/#/publicity'
          } else if (protocol === 'http:') {
              openUrl='http://aieom.digiwincloud.com.cn/#/publicity'
          }   
        }
        window.open(openUrl,'_blank');
        //tree = this.changePath("/itPro");
        break;
    }
  };
  componentDidMount() {
    setTimeout(() => {
      if (url === twLocation) {
        //台湾
        isTW = true;
        i18n.changeLanguage("zhTW");
        /* let list = routes.map(item=>{
                    item.isShow = true;
                    return item
                })*/
        this.setState({
          keyId: "1",
          log: logTW,
          lan:lanPic,
          routesList: routes,
        });
      } else {
        //大陆
        i18n.changeLanguage("zhCN");
        this.setState({
          keyId: "0",
          log: logDL,
          lan:lanPic,
          routesList: routes,
        });
      }
      document.title = title[this.state.keyId];
    }, 500);
  }
  handleMenuClick = () => {
    this.props.history.push({ pathname: "/" });
  };
  getItCloudName = () => {
    if (url === twLocation) {
      return this.props.t('ITCloud_TW');
    }else{
      return this.props.t('ITCloud_CN');
    }
  };
  render() {
    const {
      t,
      location: { pathname },
    } = this.props;
    const keys = getKey(pathname);
    const iTCloudStr = this.getItCloudName();
    const menu = (
      <Menu onClick={this.changeLan}>
        <Menu.Item key="0">
          <a rel="noopener noreferrer">{lan[0]}</a>
        </Menu.Item>
        <Menu.Item key="1">
          <a rel="noopener noreferrer">{lan[1]}</a>
        </Menu.Item>
        <Menu.Item key="2">
          <a rel="noopener noreferrer">{lan[2]}</a>
        </Menu.Item>
        <Menu.Item key="3">
          <a rel="noopener noreferrer">{lan[3]}</a>
        </Menu.Item>
        <Menu.Item key="4">
          <a rel="noopener noreferrer">{lan[4]}</a>
        </Menu.Item>
      </Menu>
    );
    const proMenu = (
      <Menu onClick={this.changMenu}>
        <Menu.Item key="first">
          <a rel="noopener noreferrer">{t("serviceCloud")}</a>
        </Menu.Item>
        <Menu.Item key="second">
          <a rel="noopener noreferrer">{iTCloudStr}</a>
        </Menu.Item>
      </Menu>
    );
    /*serviceCloud:'服务云管家',
    ITCloud:'IT智能运维',*/
    return (
      <Header
        className="q-theme-header"
        style={{
          position: "fixed",
          zIndex: 3,
          width: "100%",
          backgroundColor: "#eaeaea",
          borderBottom: "1px solid #d9d9d9",
        }}
      >
        <div className="q-fix-width pr" style={{ height: "100%" }}>
          <div className="logo">
            <img className="logo-right" alt="" src={this.state.log} />
            {t("title")}
          </div>
          <Menu
            theme=""
            mode="horizontal"
            selectedKeys={keys}
            style={{ lineHeight: "64px" }}
          >
            {this.state.routesList.map((item) => {
              if (isTW && item.isTWShow) {
                
                if (item.list.length) {
                  return (
                    <Dropdown overlay={proMenu} onClick={this.handleMenuClick}>
                      <span
                        className="ant-dropdown-link"
                        style={{ cursor: "default" }}
                        onClick={(e) => e.preventDefault()}
                      >
                        {t(item.name)}
                        <Icon
                          style={{ paddingLeft: "5px" }}
                          type="caret-down"
                        />
                      </span>
                    </Dropdown>
                  );
                } else {
                 
                  return (
                    <Menu.Item key={item.path}>
                      <Link to={item.path}>{t(item.name)}</Link>
                    </Menu.Item>
                  );
                }
              } else {
                if (!isTW && item.isCNShow) {
                  if (item.list.length) {
                    return (
                      <Dropdown
                        overlay={proMenu}
                        onClick={this.handleMenuClick}
                      >
                        <span
                          className="ant-dropdown-link"
                          style={{ cursor: "default" }}
                          onClick={(e) => e.preventDefault()}
                        >
                          {t(item.name)}
                          <Icon
                            style={{ paddingLeft: "5px" }}
                            type="caret-down"
                          />
                        </span>
                      </Dropdown>
                    );
                  } else {
                    return (
                      <Menu.Item key={item.path}>
                        <Link to={item.path}>{t(item.name)}</Link>
                      </Menu.Item>
                    );
                  }
                }
              }
            })}
          </Menu>
          <div className="languageChange pa">
            <img className="language-pic" alt="" src={this.state.lan} />
            <Dropdown overlay={menu} >
            <a className="ant-dropdown-link">
              {t(lan[this.state.keyId])}
              <Icon type="down" />
            </a>
          </Dropdown>
          </div>
          {/* <img className="language-pic"  alt="" src={this.state.lan} /> */}
          
          <div></div>
        </div>
      </Header>
    );
  }
}
export default withTranslation()(withRouter(Head));
